import FormText from 'components/form/FormText';
import type { FieldErrors, UseFormRegister } from 'react-hook-form';
import type { SignupOldCompanyFormStateType } from '../SignupOldCompany';

import type { JSX } from 'react';

export function SignupOldUserSection({
  register,
  errors,
}: {
  register: UseFormRegister<SignupOldCompanyFormStateType>;
  errors: FieldErrors<SignupOldCompanyFormStateType>;
}): JSX.Element {
  return (
    <div className="form-group">
      <h3 className="title-section title-md fw-bold">ユーザー情報</h3>
      <div className="row form-row flex-md-row justify-content-between">
        <div className="column col-lg-6 col-xl-6 col-left">
          <FormText
            subject="氏名"
            name="userName"
            register={register}
            errors={errors}
            required={true}
            maxLength={100}
            requiredMark={true}
          />
        </div>
        <div className="column col-lg-6 col-xl-6 col-right"></div>
      </div>
    </div>
  );
}
